import { render, staticRenderFns } from "./MovieData.vue?vue&type=template&id=51ad0607&"
import script from "./MovieData.vue?vue&type=script&lang=js&"
export * from "./MovieData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports